import gql from 'graphql-tag'

import Fragment from './fragment'

export const mutation = gql`
  ${Fragment}
  mutation updateDeal($id: Int!, $fields: crm_deal_set_input!) {
    record: update_crm_deal_by_pk(pk_columns: {id: $id}, _set: $fields) {
      ...DealForm
    }
  }
`

export default mutation
